module.exports = __webpack_public_path__ + "fonts/31E180_0_0.8201a2d.ttf";